import React from 'react';
import {getEnvironment} from '../../app/App';
import Cards from '../Carta/Cards';

class Header extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            urlImg: '', nameCompany: '', json: '',
            backgroundColorB: '#fffff', backgroundImagen: '', typeBackground: 2,
            colorSocialText: '#fffff', bgColorSocial: '#9b9898', fontFamily: 'cursive',
            contentWhats: ''
        }

    }


    componentDidMount(){
        this.getMenu();
    }


    getMenu() {
        console.log("idMenu: ", window.sessionMenu.idMenu);
        var idMenu ='';
        if(window.sessionMenu.idMenu === null || window.sessionMenu.idMenu === ''){
            idMenu = window.sessionMenu.idMenu;
        } else {
            idMenu = parseInt(window.sessionMenu.idMenu);
        }
        const axios = require('axios');
        var datos = new FormData();
        datos.append("idMenu", idMenu);
        let that = this;
        var confCurrent = getEnvironment();
        axios.post(confCurrent.home + 'a/get/menu/' + Date.now(), datos)
        .then(function (response) {
            console.log("menu: ",response);
            if (response.data.data.Menu != null && response.data.data.Menu !== '') {

                let contador = response.data.data.Menu.length;
                let i;
                for (i=0;i < contador; i++) {
                   if (response.data.data.Menu[i].type == 1 && response.data.data.Menu[i].subType == 4) {
                        that.setState({
                            phone: response.data.data.Menu[i].description,
                            urlRedirectPhone: response.data.data.Menu[i].urlRedirect ,
                        });
                   }

                   if (response.data.data.Menu[i].type == 2 && response.data.data.Menu[i].subType == 2 && response.data.data.Menu[i].description != "facebook") {
                       console.log('iffffff')
                         that.setState({
                             whats: response.data.data.Menu[i].description
                         });
                   }
                }

                if(response.data.data.Menu[0].urlWhats == '#') {
                    that.setState({ contentWhats: 'dis-content-whats'});
                }

                that.setState({ menu: response.data.data.Menu,
                                nameCompany: response.data.data.Menu[0].name,
                                urlImg: response.data.data.Menu[0].urlImg,
                                urlFace: response.data.data.Menu[0].urlFace,
                                urlWhats: response.data.data.Menu[0].urlWhats,
                                descriptionFace: response.data.data.Menu[0].descriptionFace,
                                json: response.data.data.Menu[0].style
                            });

                var json = JSON.parse(that.state.json);

                that.setState({ backgroundImagen: json.menu.background.imagen,
                                backgroundColorB: json.menu.background.color,
                                typeBackground: json.menu.background.type,
                                colorSocialText: json.menu.social.color,
                                bgColorSocial: json.menu.social.backgroundColor,
                                fontFamily: json.menu.social.fontFamily
                            });
            } else {
                that.setState({ menu: []});
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }


    render (){
        const s = {width: '22px' , height: '22px'};
        var confCurrent = getEnvironment();

        var bg = '';
        var background = '';
        if(this.state.typeBackground === 2) {
            background = {backgroundColor: this.state.backgroundColorB}
        } else {
            // style={{backgroundImage: "url("+confCurrent.home + "assets/images/" + com.imgBody+")"}}
            background = {backgroundImage: "url(" + confCurrent.home + "assets/images/directory/" + this.state.backgroundImagen + ")"}
            bg = 'bg-img-responsive';
        }

        const backgroundSocials = {backgroundColor: this.state.bgColorSocial}
        const colorSocialText = {color: this.state.colorSocialText, fontFamily: this.state.fontFamily }

        console.log("contentWhats: ", this.state.contentWhats);

        return (
            <React.Fragment>
                <div className="image-cover hr-banner  wd-img-company" style={{backgroundImage: "url("+confCurrent.home + "assets/images/directory/"+ this.state.urlImg + ")"}} data-overlay="6">
                        <div className="container"></div>
                </div>
                <div className="row bg-socials dis-rs1" style={backgroundSocials}>
                    <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1 wd-limk "></div>
                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-3 wd-limk">
                        <a href={this.state.urlFace} className="dis-trsocial" target="_blank">
                            <p className="txt-social-menu" style={colorSocialText}><img src={confCurrent.home + "assets/images/icons/fb_directorio.png"} alt={this.state.descriptionFace} className="img-responsive img-socials" /> {this.state.descriptionFace}</p>
                        </a>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-3 col-xs-3 wd-limk">
                        <a href={this.state.urlRedirectPhone} className="dis-trsocial">
                            <p className="txt-social-menu d" style={colorSocialText}><img src={confCurrent.home + "assets/images/icons/phone_directorio.png"} alt={this.state.phone}  className="img-responsive img-socials" /> {this.state.phone} </p>
                        </a>
                    </div>
                    <div className={"col-lg-2 col-md-3 col-sm-3 col-xs-3 wd-limk " + this.state.contentWhats}>
                        <a href={this.state.urlWhats} className="dis-trsocial"  target="_blank">
                            <p className="txt-social-menu" style={colorSocialText}><img src={confCurrent.home + "assets/images/icons/whats_directorio.png"} alt={this.state.whats} className="img-responsive img-socials"  />  {this.state.whats} </p>
                        </a>
                    </div>
                    <div className="col-lg-3 col-md-2 col-sm-1 col-xs-3 wd-limk"></div>
                </div>

                <div className="row bg-socials dis-rs2" style={backgroundSocials}>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 wd-limk">
                        &nbsp; &nbsp;&nbsp;&nbsp;
                        <a href={this.state.urlFace} style={colorSocialText} className="txt-social-menu-m" target="_blank">
                            <img src={confCurrent.home + "assets/images/icons/fb_directorio.png"} alt={this.state.descriptionFace}  className="img-responsive img-socials" /> {this.state.descriptionFace}
                        </a>&nbsp; &nbsp;
                        <a href={this.state.urlRedirectPhone} style={colorSocialText} className="txt-social-menu-m">
                            <img src={confCurrent.home + "assets/images/icons/phone_directorio.png"} alt={this.state.phone}  className="img-responsive img-socials" /> {this.state.phone}
                        </a>&nbsp; &nbsp;
                        <a href={this.state.urlWhats} style={colorSocialText} className={"txt-social-menu-m " + this.state.contentWhats}  target="_blank">
                            <img src={confCurrent.home + "assets/images/icons/whats_directorio.png"} alt={this.state.whats}  className="img-responsive img-socials"  />  {this.state.whats}
                        </a>
                    </div>
                </div>

                <section className={"pd-section " + bg} style={background}>
                    <div  className="container pd-container">
                        <div  className="tab-content">
                            <div  className="tab-pane fade in show active" role="tabpanel">
                                <Cards />
                            </div>
                        </div>
                    </div>
                </section>

                <div className="row bx-bfoter">
                    <div className="col-lg-4 col-md-4 col-sm-3 col-xs-12 pd-wfot">
                        <a href="http://rapidiux.com">
                            <img src={confCurrent.home +  "assets/images/directory/logo_modal.png"} alt="Hola" className="img-logo-slogan" />
                        </a>
                    </div>
                    <div className="col-lg-5 col-md-3 col-sm-4 col-xs-12 pd-wfot-2">
                        <h4 className="slogan">Servicio a domicilio con <a href="https://rapidiux.com"><span className="txt-softiux">rapidiux</span></a> </h4>
                    </div>
                    <div className="col-lg-3 col-md-5 col-sm-5 col-xs-12 tx-wf">
                        <a href="https://rapidiux.com/facebook" className="socials-slongan" target="_self">
                            <img src={confCurrent.home + "assets/images/icons/ico_fb_check.png"}  className="mx-auto"  alt="" style={s}/> /Rapidiux &nbsp; &nbsp;&nbsp; &nbsp;
                        </a>
                        <a href="https://rapidiux.com/7341589302" className="" target="_self">
                            <span><img src={confCurrent.home + "assets/images/icons/ico_whats_check.png"}  className=""  alt="" style={s}/> 734 158 9302 </span>
                        </a>
                    </div>
                </div>

                <footer className={"dark-footer skin-dark-footer "}>
                    <div className="footer-bottom footer-btn">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-12 col-md-12 text-center">
                                  <p className="mb-0 txt-footer">© 2020 Rapidiux. Design By <a className="txt-sof" href="https://softiux.com">SoftiUX</a> All Rights Reserved</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </ React.Fragment>
        )
    }
}

export default Header;
